import { useMemo } from "react";
import createImageProps from "../../../components/image/createImageProps";
import type { MediaProps } from "@bmi-digital/components/dist/media";
import type { ImageTrainingDetail } from "../../../components/image/types";
import type { Theme } from "@mui/material/styles";

type Props = {
  courseName: string;
  courseImageUrl: string; // Can be an empty string if an image was added in Docebo
  fallbackImageData: ImageTrainingDetail | null;
  theme: Theme;
};

const useTrainingDetailsImage = ({
  fallbackImageData,
  courseImageUrl,
  courseName,
  theme
}: Props): MediaProps => {
  return useMemo(() => {
    if (courseImageUrl) {
      return { src: courseImageUrl, alt: courseName };
    }

    if (fallbackImageData) {
      return createImageProps(
        { ...fallbackImageData, altText: courseName },
        theme
      );
    }

    return { alt: courseName, src: "" };
  }, [fallbackImageData, courseImageUrl, courseName]);
};

export default useTrainingDetailsImage;
